import _styled3 from "styled-components";
import _styled2 from "styled-components";
import _styled from "styled-components";
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import get from 'lodash.get';
import React, { useContext, useMemo, useCallback } from 'react';
import Help from '../../help/Help';
import Label from '../../label/Label';
import FieldGroupContext from '../FieldGroupContext';
import { useFormContext } from '../FormContext';
import { getError, getFieldId } from '../utils';
import * as style from './withField.style';
export const FieldWrapper = _ref => {
  let {
    children
  } = _ref;
  return /*#__PURE__*/React.createElement(_StyledDiv, {
    $_css: style.wrapper
  }, children);
};
function withField(ControlComponent) {
  const FormField = _ref2 => {
    let {
      id,
      name,
      label,
      help,
      dataRef,
      hasErrorTooltip,
      value,
      onChange,
      disabled: externalDisabled,
      onBlur,
      required,
      ...rest
    } = _ref2;
    const {
      loading,
      disabled,
      values,
      errors,
      touched,
      submitCount,
      handleBlur,
      handleChange
    } = useFormContext();
    const {
      showGroupError
    } = useContext(FieldGroupContext);
    const error = useMemo(() => getError(submitCount > 0, name, touched, errors), [errors, name, submitCount, touched]);
    const computedId = useMemo(() => id || getFieldId(name), [id, name]);
    const refName = useMemo(() => dataRef || name, [dataRef, name]);
    const fieldProps = useMemo(() => ({
      value: value !== undefined ? value : get(values, name, undefined),
      valid: submitCount > 0 && get(touched, name) && !get(errors, name),
      disabled: loading || disabled || externalDisabled
    }), [disabled, errors, externalDisabled, loading, name, submitCount, touched, value, values]);
    const internalHandleChange = useCallback(e => {
      handleChange(e);
      if (onChange) {
        onChange(e);
      }
    }, [handleChange, onChange]);
    const internalHandleBlur = useCallback(e => {
      handleBlur(e);
      if (onBlur) {
        onBlur(e);
      }
    }, [handleBlur, onBlur]);
    const WrapperComponent = hasErrorTooltip ? FieldWrapper : React.Fragment;
    return /*#__PURE__*/React.createElement(WrapperComponent, null, label && /*#__PURE__*/React.createElement(Label, {
      htmlFor: computedId,
      text: label,
      dataRef: `${refName}-label`,
      required: required
    }), /*#__PURE__*/React.createElement(ControlComponent, _extends({}, rest, fieldProps, {
      id: computedId,
      name: name,
      error: error,
      onChange: internalHandleChange,
      onBlur: internalHandleBlur,
      dataRef: `${refName}-control`
    })), !showGroupError && error && !hasErrorTooltip && /*#__PURE__*/React.createElement(Help, {
      error: !!error
    }, typeof error === 'object' ? Object.keys(error).map(key => error[key]).join(', ') : error), !showGroupError && error && hasErrorTooltip && /*#__PURE__*/React.createElement(_StyledDiv2, {
      "data-ref": `${refName}-error-tooltip`,
      $_css2: style.errorTooltip
    }, /*#__PURE__*/React.createElement(_StyledDiv3, {
      $_css3: style.errorTooltipArrow
    }), /*#__PURE__*/React.createElement("span", null, error)), help && /*#__PURE__*/React.createElement(Help, null, help));
  };
  return FormField;
}
export default withField;
var _StyledDiv = _styled("div").withConfig({
  displayName: "withField___StyledDiv",
  componentId: "sc-2pybct-0"
})(["", ""], p => p.$_css);
var _StyledDiv2 = _styled("div").withConfig({
  displayName: "withField___StyledDiv2",
  componentId: "sc-2pybct-1"
})(["", ""], p => p.$_css2);
var _StyledDiv3 = _styled("div").withConfig({
  displayName: "withField___StyledDiv3",
  componentId: "sc-2pybct-2"
})(["", ""], p => p.$_css3);
//# sourceMappingURL=withField.js.map